var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rph-location"},[_c('button',{staticClass:"rph-location-btn",on:{"click":_vm.setPosition}},[_c('PositionIcon'),_vm._v("Определить")],1),_vm._v(" "),_c('input',{staticClass:"rph-location-input",attrs:{"id":"search","type":"text","disabled":""},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }